import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M15 .018V13h16.92q.065 1.02.077 2H15v16.982a54 54 0 0 1-2-.089V15H.004c.01-.65.038-1.32.087-2h12.91V.106a54 54 0 0 1 2-.088",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M17 .018V15h14.997q.006.516 0 1.016.006.485-.001.984H17v14.983A63 63 0 0 1 16 32a58 58 0 0 1-1-.018V17H.003a39 39 0 0 1 0-1.017Q-.003 15.5.004 15H15V.018Q15.5.004 16 0q.5.005 1 .018",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M19 .107V17h12.996c-.01.65-.038 1.32-.087 2h-12.91v12.899c-.656.04-1.326.067-2 .084V19H.083a36 36 0 0 1-.08-2H17V.018c.673.017 1.343.047 2 .09",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M19.684 22.349a7.39 7.39 0 0 1-7.368 0A7.26 7.26 0 0 1 8.666 16a7.26 7.26 0 0 1 3.65-6.349 7.39 7.39 0 0 1 7.368 0A7.26 7.26 0 0 1 23.333 16a7.26 7.26 0 0 1-3.65 6.349",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "m15.412 11.142.588-.409.588.41-.207-.686.57-.433-.716-.014L16 9.333l-.235.677-.716.014.57.433zm2.968.583.716.014.235.677.235-.677.716-.014-.57-.433.207-.685-.588.409-.588-.41.207.686zm2.629 2.648-.57-.433.715-.015.235-.676.236.676.715.015-.57.433.207.685-.588-.41-.587.41zm-.207 2.57.207.684-.57.433.715.015.235.676.236-.676.715-.015-.57-.432.207-.686-.588.41zm-1.706 3.318.235-.677.235.677.716.015-.57.432.207.686-.588-.41-.588.41.207-.686-.57-.432zm-2.508.597-.588.409-.588-.41.208.686-.571.433.716.014.235.677.235-.677.716-.014-.57-.433zm-3.684-.597.716.015-.57.432.207.686-.588-.41-.588.41.208-.686-.57-.432.715-.015.235-.677zm-1.342-2.2-.57-.433.206-.686-.587.41-.588-.41.207.686-.57.432.716.015.235.676.235-.676zm-.57-3.688.206.685-.587-.41-.588.41.207-.685-.57-.433.716-.015.235-.676.235.676.716.015zm1.677-1.957.235-.677.716-.014-.57-.433.207-.685-.588.409-.588-.41.208.686-.57.433.715.014z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C56B8",
      fillRule: "evenodd",
      d: "M15.266 13.184s-.34-.55-.354-.57c-.115-.153.138-.377.354-.5.118-.065.554-.16.961.046.437.22.83.81 1.03.83-.081.088-.366-.015-.478-.033.2.13.429.333.6.274-.122.138-.074.206-.235.2.197.076.314.204.463.177-.072.13-.269.23-.269.23s.184.185.37.13c-.07.126-.247.222-.247.222s.039.184.344.15c-.37.546-1.158 4.034-1.472 3.915s-1.455-1.059-1.65-2.255c-.198-1.226.583-2.816.583-2.816",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E5B731",
      fillRule: "evenodd",
      d: "M15.159 12.862c.044.02.21.126.034.29-.11.102-.395.133-.46.08-.075.062-.067.14-.099.243-.29-.452-.104-.825.275-.893.325-.082.25.28.25.28",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M18.088 19.053c.044-.17.065-1.478-.188-2.59-.215-.943-.682-1.7-.924-1.972-.149-.167-.442-.354-.607-.515-.09-.188-.073-.717-.225-.717-.135 0-.521.053-.899-.035a1.34 1.34 0 0 0-.222.587c.07.321.633.323.829.438-.128.93.517 2.604.517 2.604s-.305.23-.225 1.322c-.17-.124-.77-.814-.673-.594-.104.965 1.558 2.62 1.845 2.785.529.06.584-1.711.584-1.711s.172.33.188.398",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C4A00",
      fillRule: "evenodd",
      d: "M14.767 18.706c.055.139.01.276.081.277.073.002 2.982-.075 3.052.042s.08.346.007.436c-.074.091-3.763.126-3.848.032-.085-.093-.209-.486-.208-.51.26-.018.233-.235.365-.348s.495-.068.55.07",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FCD116",
      fillRule: "evenodd",
      d: "M16.33 19.717c.004.022-.037.175-.247 0-.02.167-.498-.018-.534-.389-.022-.392.438-.694.462-.471 0 .006.242-.012.446 0 .176.01.32.049.322.074.019.175-.22.113-.202.341s.337.209.356.399c.01.149-.28.088-.392-.033.08.124-.11.233-.211.08",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagDma = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagDma_default = SvgFlagDma;

export { FlagDma_default as default };
